import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PACKAGE_PRICE_PAGINATION } from "../Schema/PackagePrice";

const useGetPackagePricePagination = ({classId, groupFeeId}) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { refetch } = useQuery(GET_PACKAGE_PRICE_PAGINATION, {
    variables: {
      page:page,
      limit: limit,
      pagination: true,
      classId: classId || null,
      groupFeeId:groupFeeId || null,
    },
    onCompleted:({getPackagePricePagination}) => {
      setTableData(getPackagePricePagination?.data);
      setPaginationData(getPackagePricePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.error("Error fetching content:", err.message);
    },
  });

  useEffect(() => {
    refetch();
  },[page, limit, classId, groupFeeId]);

  const handleLimit = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    tableData,
    paginationData,
    handleLimit,
  };
};

export default useGetPackagePricePagination;